import { isObject } from 'lodash';

/**
 * Normalizes media URLs in a GraphQL JSON response by replacing `-/media/` with `/-/media`.
 *
 * Note: This is a temporary solution for handling inconsistent media URL prefixes during the migration.
 * After the full migration, update the Media.MediaLinkPrefix setting in the Common.Media.config file
 * in Sitecore to use the correct prefix (/-/media) and remove this function.
 *
 * @param data - JSON object received from the GraphQL response.
 * @returns The normalized JSON object.
 */
export const normalizeMediaUrls = <T extends Record<string, unknown>>(data: T): T => {
  if (!isObject(data)) return data;

  const transform = (value: unknown): unknown => {
    if (Array.isArray(value)) {
      return value.map(transform);
    } else if (value && isObject(value)) {
      const result: Record<string, unknown> = {};
      for (const [key, val] of Object.entries(value)) {
        result[key] = transform(val);
      }
      return result;
    } else if (typeof value === 'string' && value.startsWith('-/media/')) {
      return `/${value}`;
    }

    return value;
  };

  return transform(data) as T;
};
